import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import logoDlb from "../../img/djb.png";
import QRCode from "qrcode";
import { decryptAesObj } from "./AESencryptdecrypt";

// ✅ import the Hindi font you converted
import notoDevanagari from "../../fonts/NotoSansDevanagari-Regular-normal";

// ✅ register Hindi font globally in jsPDF
jsPDF.API.events.push([
  "addFonts",
  function () {
    this.addFileToVFS("NotoSansDevanagari-Regular.ttf", notoDevanagari);
    this.addFont(
      "NotoSansDevanagari-Regular.ttf",
      "NotoSansDevanagari",
      "normal",
    );
  },
]);

class ExportPdf extends React.Component {
  constructor() {
    super();
    this.state = { qrCodeDataUrl: null };
  }

  generateQrCode = async () => {
    try {
      let qrValue = localStorage.getItem("lastGeneratedQrCode");

      if (!qrValue) {
        return { qrDataUrl: null, qrValue: null };
      }

      const qrUrl = `${window.location.origin}/report-card.html?code=${qrValue}`;

      const qrDataUrl = await QRCode.toDataURL(qrUrl, {
        errorCorrectionLevel: "H",
        margin: 2,
        scale: 10,
        width: 400,
      });

      return { qrDataUrl, qrValue };
    } catch (error) {
      console.error("Error generating QR code:", error);
      return { qrDataUrl: null, qrValue: null };
    }
  };

  exportPDF = async () => {
    const doc = new jsPDF("l", "mm", [297, 241]);

    // ✅ set the Hindi font globally
    doc.setFont("NotoSansDevanagari");
    doc.setFontSize(15);

    // Add Logo
    const logoX = 15;
    const logoY = 30;
    const logoWidth = 70;
    const logoHeight = 25;
    doc.addImage(logoDlb, "PNG", logoX, logoY, logoWidth, logoHeight);

    // Title below logo
    const title = this.props.title || "System Report";
    doc.setFont("NotoSansDevanagari", "normal");
    doc.setFontSize(12);
    doc.text(title, logoX, logoY + logoHeight + 8, { align: "left" });

    // Generate QR Code
    const { qrDataUrl, qrValue } = await this.generateQrCode();

    if (qrDataUrl) {
      const qrX = 240;
      const qrY = 15;
      const qrWidth = 45;
      const qrHeight = 45;

      doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrWidth, qrHeight);
      doc.setFontSize(9);
      doc.text(
        "Scan for report details",
        qrX + qrWidth / 2,
        qrY + qrHeight + 5,
        {
          align: "center",
        },
      );
    }

    // Prepare Table Headers
    let headers = [];
    if (this.props.type === "report") {
      const headerRow = this.props.labelHeader.map((el) => el.name);
      headers.push(headerRow);
    } else {
      headers = [this.props.labelHeader];
    }

    // Prepare Table Data
    let data = [];
    if (this.props.type === "report") {
      this.props.exportData.forEach((el) => {
        const row = this.props.labelHeader.map(
          (element) => el[element.keyName],
        );
        data.push(row);
      });
    } else {
      data = this.props.exportData.map((elt) => [
        elt.col1,
        elt.col2,
        elt.col3,
        elt.col4,
        elt.col5,
        elt.col6,
        elt.col7,
        elt.col8,
        elt.col9,
        elt.col10,
        elt.col11,
        elt.col12,
        elt.col13,
        elt.col14,
        elt.col15,
        elt.col16,
      ]);
    }

    // Table Styling
    const content = {
      startY: 70,
      head: headers,
      body: data,
      styles: {
        fontSize: 8,
        font: "NotoSansDevanagari", // ✅ ensures Hindi text renders in table
      },
    };

    // Add the table
    doc.autoTable(content);

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFont("NotoSansDevanagari", "normal");
      doc.setFontSize(10);

      const userEmail =
        this.props.userEmail ||
        (localStorage.getItem("data")
          ? decryptAesObj(localStorage.getItem("data"))?.email
          : "System");

      doc.text(
        `Generated by: ${userEmail}, Generated at: ${moment(new Date()).format(
          "DD-MM-YYYY hh:mm A",
        )}`,
        15,
        doc.internal.pageSize.height - 10,
      );

      doc.text(
        `Page ${i} of ${pageCount}`,
        doc.internal.pageSize.width - 50,
        doc.internal.pageSize.height - 10,
      );
    }

    // Save file
    doc.save(
      `${this.props.reportName || "Report"}(${moment(new Date()).format(
        "DD-MM-YYYYThh:mm:ss",
      )}).pdf`,
    );
  };

  render() {
    return (
      <div>
        <div
          id={this.props.id ? this.props.id : "exportPdfButton"}
          onClick={() => this.exportPDF()}
        >
          <PictureAsPdfIcon />
        </div>
      </div>
    );
  }
}

export default ExportPdf;
